"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _removeFocusOnMouseUp = _interopRequireDefault(require("../../utils/removeFocusOnMouseUp"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ButtonOrLink = /*#__PURE__*/_react.default.forwardRef(({
  afterIcon,
  beforeIcon,
  children,
  disabled = false,
  href = '',
  loading = false,
  openInNewWindow = false,
  rel,
  trackingName,
  trackingEvent,
  type = 'button',
  download,
  target,
  tabIndex,
  onClick,
  onMouseUp,
  onEnterKeyPress,
  onEscapeKeyPress,
  onCustomKeyPress,
  onKeyPress,
  ...restProps
}, ref) => {
  // Intercept click to handle disabled state
  const handleClick = event => {
    if (disabled || loading) {
      event.preventDefault();
    } else if (onClick) {
      onClick(event);
    }
  };

  // Remove outline after click
  const handleMouseUp = event => {
    (0, _removeFocusOnMouseUp.default)(event);
    if (onMouseUp) {
      onMouseUp(event);
    }
  };
  const handleKeyPress = event => {
    if (onEnterKeyPress && event.key === 'Enter') onEnterKeyPress(event);
    if (onEscapeKeyPress && event.key === 'Escape') onEscapeKeyPress(event);
    if (onCustomKeyPress && event.key === onCustomKeyPress.key) onCustomKeyPress.action(event);
    if (onKeyPress) onKeyPress(event);
  };
  (0, _react.useEffect)(() => {
    const hasKeyPressEvents = onEnterKeyPress || onEscapeKeyPress || onKeyPress || onCustomKeyPress;
    if (!hasKeyPressEvents) return;
    window.addEventListener('keyup', handleKeyPress);
    return () => {
      window.removeEventListener('keyup', handleKeyPress);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const Tag = href ? 'a' : 'button';
  const props = {};

  // Determine props based on element type
  if (href) {
    props.href = href;
    props.rel = rel;
    props.download = download;
    if (target) props.target = target;
    if (openInNewWindow) {
      props.target = '_blank';
      if (props.rel === undefined) {
        props.rel = 'noopener noreferrer';
      }
    }
  } else {
    props.disabled = disabled || loading || false;
    props.type = type || 'button';
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Tag, {
    ...restProps,
    ...props,
    ref: ref,
    "data-tracking-name": trackingName,
    "data-tracking-event": trackingEvent,
    onClick: handleClick,
    onMouseUp: handleMouseUp,
    download: download,
    tabIndex: tabIndex,
    children: [!loading && beforeIcon ? beforeIcon : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: children
    }), !loading && afterIcon ? afterIcon : null]
  });
});
var _default = exports.default = ButtonOrLink;